//consolidate

import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'

import { DS } from '@/design-system'

import { formatChipsNumber } from '@/components/GameAssets/Player/PlayerBox'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import { defaultTheme } from '@/components/Mini/theme'


function CthStreakStats(){

  const roundCount = cth.useStore(s => s.ROUND_COUNT)
  
  const { stats }  = cth.useCthQueryHistory()

  const handleLog = cth.useHandleLog()

  const theme = cth.useStore(s => s.theme)

  const data = [
    {"label": "Current Streak", "value": `${stats?.currentStreak ?? 0}`},
    {"label": "Longest Streak", "value": `${stats?.longestStreak ?? 0}`},
    {"label": "Best Rounds", "value": `${stats?.bestScore ?? 0}/${roundCount}`},
  ]

  return (
    <StreakStats theme={theme} data={data} handleLog={handleLog} />
  )
}

function PocketPickStreakStats(){

  const roundCount = pocketPick.useStore(s => s.ROUND_COUNT)
  
  const { stats }  = pocketPick.usePocketPickQueryHistory()

  const handleLog = pocketPick.useHandleLog()

  const theme = pocketPick.useStore(s => s.theme)

  const data = [
    {"label": "Current Streak", "value": `${stats?.currentStreak ?? 0}`},
    {"label": "Longest Streak", "value": `${stats?.longestStreak ?? 0}`},
    {"label": "Best Rounds", "value": `${stats?.bestScore ?? 0}/${roundCount}`},
  ]

  return (
    <StreakStats theme={theme} data={data} handleLog={handleLog} />
  )
}

function D10StreakStats(){

  const m = d10
  
  const { stats }  = m.useD10QueryHistory()

  const handleLog = m.useHandleLog()

  const theme = m.useStore(s => s.theme)

  const data = [
    {"label": "Current Streak", "value": `${stats?.currentStreak ?? 0}`}, //
    {"label": "Longest Streak", "value": `${stats?.longestStreak ?? 0}`}, //
    {"label": "Best Score", "value": `${formatChipsNumber(stats?.bestChips ?? 0)}`},
  ]

  return (
    <StreakStats theme={theme} data={data} handleLog={handleLog} />
  )
}

type StreakItem = { label: string; value: string }

function StreakStats({ theme=defaultTheme, data, handleLog }: { theme?: typeof defaultTheme; data: StreakItem[]; handleLog: () => void }) {

  //card background theme.surface
  //card border theme.surfaceBorder
  //header title theme.accent
  //header arrow theme.textDefault
  //stat value theme.textDefault,
  //stat label theme.textDefaultDim,

  return (
   <TouchableOpacity style={[styles.card, {backgroundColor:theme.surface, borderColor: theme.surfaceBorder}]} onPress={handleLog} activeOpacity={0.8}>

      {/*header*/}
      <View style={styles.header}>
        <DS.Text variant="Heading 3/Medium" style={{color: theme.accent, lineHeight: 30, textAlign: 'center'}}>
          Your Stats
        </DS.Text>
        <View style={styles.headerArrow}>
          <DS.Icon name="Arrow---right" size={20} color={theme.textDefault} />
        </View>
      </View>

      <View style={styles.statsRow}>
        {data.map(function (d, i){
          return <StreakStat key={"stat"+i} theme={theme} label={d.label} value={d.value} />
        })}
      </View>
      
    </TouchableOpacity>

  )
}

function StreakStat({ theme, label, value }: { theme: typeof defaultTheme; label: string; value: string }) {

  const valueTextColor = theme.textDefault
  const labelTextColor = theme.isDark ? theme.textDefaultDim : theme.textDefault

  return (
    <View style={styles.statBox}>
      <DS.Text variant="Heading 2/Medium" style={{color:valueTextColor}}>
        {value}
      </DS.Text>
      <DS.Text variant="Body Small/Regular" style={{color:labelTextColor}}>
        {label}
      </DS.Text>
    </View>
  )
}



const styles = StyleSheet.create({
  card: {
    borderRadius: 20,
    padding: 20,
    borderWidth: 1,
    gap: 20
  },
  statsRow: { flexDirection: 'row', justifyContent: 'space-evenly' },
  statBox: { alignItems: 'center', gap: 4 },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  headerArrow: { position: 'absolute', right: 0 }
})

export { CthStreakStats, D10StreakStats, PocketPickStreakStats }
